export default __webpack_public_path__ + "static/media/eightyTwentyBanner.a1e67497.png";